var map = {
	"./Arquee_Photo not mine(credits to the owner)png.png": 788,
	"./Concentrix.jpeg": 845,
	"./Happy Tan.jpg": 432,
	"./Photo by Convergent Outsourcing Solutions Inc..jpg": 955
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 234;